import { SvgIcon } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';

const ThemedSvgIcon = ({ children, fill, ...props }) => {
    const theme = useTheme();
    const iconFill = fill || theme.palette.icon.default;

    return <SvgIcon {...props}>{typeof children === 'function' ? children(iconFill) : children}</SvgIcon>;
};

ThemedSvgIcon.propTypes = {
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
    fill: PropTypes.string,
};

export default ThemedSvgIcon;
